import { EloquentService } from "@/services/api/eloquent.api.service"
import {SuperadminService} from "@/services/api/superadmin.api.service"

const state = {
    tariff: null,
    payStatus: null,
    billingPayment: null,
    userIdToImitateLogin: null,
    superadmins: []
}

const getters = {

}

const mutations = {
    setTariff(state, data) {
        state.tariff = data
    },
    setPayStatus(state, data) {
        state.payStatus = data
    },
    setBillingPayment(state, data) {
        state.billingPayment = data
    },
    setUserIdToImitateLogin(state, data) {
        state.userIdToImitateLogin = data
    },
    setSuperadmins(state, data) {
        state.superadmins = data
    }
}

const actions = {
    getSuperAdminClinic(context, id) {
        return new Promise((resolve, reject) => {
            EloquentService.show('clinic', id, true).then(data => {
                let d = data.data
                resolve(d)
            }).catch(err => {
                reject(err.response.data.errors)
            })
        })
    },
    getSuperadmins(context) {
        return new Promise((resolve, reject) => {
            SuperadminService.getSuperadmins().then(data => {
                let d = data.data
                context.commit('setSuperadmins', d.data)
                resolve(d)
            }).catch(err => {
                reject(err.response.data.errors)
            })
        })
    }
};

export default {
    state,
    actions,
    mutations,
    getters
}
